import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import t from "../../../utils/common/translation/translator";
import AxisComponent from "../Axes/AxisComponent";
import {
  selectCurrentAxisFilters,
  setAxisFilters,
  setCurrentAxisId,
  setCurrentFiltersStepperStep,
  setShowAxisPopup,
  unsetBundle
} from "../../../store/slices/retrofit";
import CustomPopup from "../../common/CustomPopup/CustomPopup";
import { formatNbPhases } from "./Filters/utils";
import { updateConfiguration } from "../../../store/slices/common";

const EditAxisPopup = ({ opened, axisId, setEditAxisPopupOpened, axis }) => {
  const dispatch = useDispatch();

  const axisFilters = useSelector(selectCurrentAxisFilters);

  const [initialFilters, setInitialFilters] = useState(useSelector(selectCurrentAxisFilters));

  const dynamicInitialFilters = useSelector(selectCurrentAxisFilters);
  const [checkInputs, setCheckInputs] = useState(false);

  useEffect(() => {
    setInitialFilters(dynamicInitialFilters);
  }, [opened]);

  const [confirmationPopupOpened, setConfirmationPopupOpened] = useState(false);

  const [childHandleExecSyncFilters, setChildHandleExecSyncFilters] = useState(null);

  const handleCallback = (func) => {
    setChildHandleExecSyncFilters(() => func);
  };

  const syncApplicationDataFilters = async () => {
    if (childHandleExecSyncFilters) {
      await childHandleExecSyncFilters(true);
    }
  };

  const handleApplyChanges = async () => {
    await syncApplicationDataFilters();
    const bundle = axis?.bundle;
    const bundleSelected = bundle?.motorReference !== undefined && bundle?.motorReference !== null;
    // check if the new filters are compatible with the bundle selection
    // if a bundle is selected and
    // if the nominal torque is higher than the max torque of the bundle
    // or the nominal speed is higher than the max speed of the bundle
    // if the maxLength is set and higher than the length of the bundle
    // then display a popup to warn the user
    if (!axisFilters?.applicationDataFilter?.nominalTorque || !axisFilters?.applicationDataFilter?.nominalSpeed) {
      setCheckInputs(true);
      return;
    }
    setCheckInputs(false);
    if (
      bundleSelected &&
      (Number(axisFilters?.applicationDataFilter?.nominalTorque) > bundle.bundleData?.nominalTorque ||
        Number(axisFilters?.applicationDataFilter?.nominalSpeed) > bundle.bundleData?.nominalSpeed ||
        (axisFilters?.applicationDataFilter?.maxLength !== "" &&
          Number(axisFilters?.applicationDataFilter?.maxLength) > bundle.bundleData?.length) ||
        bundle.bundleData?.drive?.communicationInterfacesAsString?.indexOf(axisFilters?.driveFilter?.driveInterface) ===
          -1 ||
        formatNbPhases(bundle.bundleData?.drive?.nbPhases)?.[0] !== bundle.bundleData?.drive?.nbPhases?.[0] ||
        bundle.bundleData?.drive?.outputVoltagesAsString?.indexOf(axisFilters?.driveFilter?.driveVoltages?.[0]) === -1)
    ) {
      // display a popup to warn the user
      setConfirmationPopupOpened(true);
    } else {
      setEditAxisPopupOpened(false);
      dispatch(updateConfiguration());
    }
  };

  const handleCancelChanges = async () => {
    if (initialFilters !== undefined) {
      dispatch(setAxisFilters({ axisId, filters: initialFilters }));
    }
    setTimeout(async () => {
      await syncApplicationDataFilters();
      setEditAxisPopupOpened(false);

      setConfirmationPopupOpened(false);
      dispatch(updateConfiguration());
      setEditAxisPopupOpened(false);
    }, 100);
  };

  const selectBundleForTheCurrentAxis = () => {
    dispatch(setCurrentAxisId(axisId));
    dispatch(setCurrentFiltersStepperStep(1));
    dispatch(setShowAxisPopup(true));
  };

  return (
    <>
      <CustomPopup
        opened={opened}
        headerTitle={t("msizer.ui.popup.edit_axis.title")}
        continueLabel={t("msizer.ui.popup.button.apply")}
        continueAction={() => {
          handleApplyChanges();
        }}
        cancelLabel={t("msizer.ui.popup.button.cancel")}
        cancelAction={() => {
          handleCancelChanges();
        }}
        onClose={() => {
          // console.log("onClose");
          handleCancelChanges();
        }}
        fullWidth
        minimal
        closeOnDocumentClick={false}
      >
        <AxisComponent onMounted={handleCallback} axisId={axisId} minimal checkInputs={checkInputs} />
      </CustomPopup>

      <CustomPopup
        opened={confirmationPopupOpened}
        headerTitle={t("msizer.ui.popup.confirm_select_new_bundle.title")}
        continueLabel={t("msizer.ui.popup.button.continue")}
        continueAction={() => {
          // the new inputs are applied => the user is redirected to the bundle selection directly
          dispatch(unsetBundle());
          setConfirmationPopupOpened(false);
          setEditAxisPopupOpened(false);
          selectBundleForTheCurrentAxis();
        }}
        cancelLabel={t("msizer.ui.popup.button.cancel")}
        cancelAction={() => {
          // the popup and edit application inputs pop-up are closed and the changes are cancelled
          handleCancelChanges();
        }}
        // onClose={() => {
        // }}
        text={t("msizer.ui.popup.confirm_select_new_bundle.text")}
        minimal
        closeOnDocumentClick={false}
      />
    </>
  );
};

EditAxisPopup.propTypes = {
  opened: PropTypes.bool,
  axisId: PropTypes.number.isRequired,
  axis: PropTypes.object.isRequired,
  setEditAxisPopupOpened: PropTypes.func
};

EditAxisPopup.defaultProps = {
  opened: false,
  setEditAxisPopupOpened: undefined
};

export default EditAxisPopup;
